import { HashRouter as Router, Route, Switch } from 'react-router-dom';

import AppInternal from './internal/App';
import AppExternal from './external/App';
import Version from './Version';

import '../../node_modules/bootstrap-css-only/css/bootstrap.min.css';
import '../css/stylesheet.css';
import PrivateRoute from '../utils/authentication';

export const AppTitle = "Tuner4TRONIC Cloud";

const App = () => {

    document.title = AppTitle;

    return (
        <Router>
            <div className="ui app">
                <div className="external-container">
                    <Switch>
                        <Route path="/login" component={AppExternal} />
                        <Route path="/options" component={AppExternal} />
                        <Route path="/version" component={Version} />
                        <PrivateRoute path="/" component={AppInternal} />

                        <Route component={AppExternal} />
                    </Switch>
                </div>
            </div>
        </Router>
    );
};

export default App;
